import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createMediaEmbedding } from "#/api/mediaReference.api";
import { useToast } from "#/hooks/ToastContext";

export function useCreateMediaEmbedding() {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => createMediaEmbedding(id),
    onSuccess: (result) => {
      showToast(
        result.created
          ? "Embedding created"
          : "Embedding already exists",
        "success"
      );
      queryClient.invalidateQueries({ queryKey: ["media", "search"] });
    },
    onError: (error) => {
      showToast(
        error instanceof Error ? error.message : "Failed to create embedding",
        "error"
      );
    },
  });
}
